<section>
  <app-visual-data />
</section>

<section
  class="sales-wrapper"
  *ngIf="(topSales$ | async) as topSales; else eventsPlaceholder">

  <div class="sales-header">
    <h2>Largest Sales</h2>

  
    <div class="period-select-wrapper">
      <ng-select
        [items]="stateSvc.periods"
        [clearable]="false"
        [searchable]="false"
        bindValue="key"
        bindLabel="value"
        [(ngModel)]="stateSvc.defaultTopSalesPeriod"
        (change)="setActiveTopSalesPeriod($event)">
      </ng-select>
    </div>

    <div style="flex-grow: 1"></div>

    <div class="filters" *ngIf="environment.collection != 'cryptophunks'">
      <button class="hide-flash-loans" (click)="toggleFlashLoans()">
        {{ (stateSvc.hideFlashLoans$ | async) ? 'Show' : 'Hide' }} Flash Loans
      </button>
    </div>
  </div>

  <div class="sales-items">
    <a
      [routerLink]="['/details', event.tokenId]"
      [href]="'/details/' + event.tokenId"
      class="sale-item"
      [class]="event.type | lowercase"
      *ngFor="let event of topSales; trackBy: trackByFn; let i = index">

      <span class="index">{{ i + 1 }}</span>

      <div class="image-wrapper">
        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (event.tokenId | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
          width="160"
          height="160"
        />
      </div>

      <div class="labels-wrapper">
        <div class="token-id">#{{ event.tokenId }}</div>

        <div class="label">
          <ng-container>
            
            <ng-container
              *ngIf="
                event.toAccount &&
                (event.type === 'Transferred' ||
                event.type === 'Wrapped' || 
                event.type === 'Unwrapped')">

              <app-wallet-address
                [address]="event.toAccount.id">
              </app-wallet-address>
            </ng-container>

            <ng-container *ngIf="event.value !== '0'">
              Ξ{{ event.value | weiToEth | formatCash }}
              (${{ ((event.value | weiToEth) | usd : event.usd) | formatCash }})
            </ng-container>
          </ng-container>

          <div class="date">
            {{ (+event.blockTimestamp * 1000) | date : 'MMM d, y' }}
          </div>
        </div>
      </div>
    </a>
  </div>
</section>

<section
  class="events-wrapper"
  *ngIf="(events$ | async) as recent; else eventsPlaceholder">

  <div class="events-header">
    <h2>Recent Transactions</h2>
    
    <ng-select
      [items]="txFilters"
      [clearable]="false"
      [searchable]="false"
      bindValue="value"
      bindLabel="label"
      [(ngModel)]="_activeTxFilter"
      (change)="setActiveTxFilter($event)">
    </ng-select>
  </div>

  <div class="events-items">
    <a
      [routerLink]="['/details', event.tokenId]"
      [href]="'/details/' + event.tokenId"
      class="event-item"
      [class]="event.type | lowercase"
      *ngFor="let event of recent; trackBy: trackByFn;">

      <div class="image-wrapper">
        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (event.tokenId | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
          width="160"
          height="160"
        />
      </div>

      <div class="labels-wrapper">

        <div class="token-id">#{{ event.tokenId }}</div>

        <div class="label">
          <ng-container>

            {{ labels[event.type] }}
            
            <ng-container
              *ngIf="
                event.toAccount &&
                (event.type === 'Transferred' ||
                event.type === 'Wrapped' || 
                event.type === 'Unwrapped')">

              <app-wallet-address
                [address]="event.toAccount.id">
              </app-wallet-address>
            </ng-container>

            <ng-container *ngIf="event.value !== '0'">
              Ξ{{ event.value | weiToEth }}
              <!-- ({{ ((event.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | currency }}) -->
              (${{ ((event.value | weiToEth) | usd : event.usd) | formatCash }})
            </ng-container>

            
            <ng-container *ngIf="event.type === 'Offered' && event.toAccount && event.toAccount?.id !== ZERO_ADDRESS">
               to 
              <app-wallet-address
                [address]="event.toAccount.id">
              </app-wallet-address>
            </ng-container>            
          </ng-container>

          <div class="date">
            {{ (+event.blockTimestamp * 1000) | timeago : true }}
          </div>
        </div>

        <!-- <span class="date">{{ (+event.blockTimestamp / 1000) | timeago : true }}</span> -->
      </div>
    </a>
  </div>
</section>

<ng-template #topSalesPlaceholder>
  <section class="sales-wrapper">
    <h2>Largest Sales</h2>
    <div class="sales-items">
      <div class="sales-item" *ngFor="let i of [1,1,1,1,1,1,1,1,1,1,1,1]">
        <div class="image-wrapper placeholder">
          <img
            [lazyLoad]="'assets/loadingpunk.png'"
            [defaultImage]="'assets/loadingpunk.png'"
            width="160"
            height="160"
          />
        </div>
  
        <div class="labels-wrapper">
          <div class="token-id">#0000</div>
          <div class="label">Loading...<br />&nbsp;</div>
        </div>
      </div>
    </div>
  </section>
</ng-template>

<ng-template #eventsPlaceholder>
  <section class="events-wrapper">
    <h2>Recent Transactions</h2>
    <div class="events-items">
      <div class="event-item" *ngFor="let i of [1,1,1,1,1,1,1,1,1,1,1,1]">
        <div class="image-wrapper placeholder">
          <img
            [lazyLoad]="'assets/loadingpunk.png'"
            [defaultImage]="'assets/loadingpunk.png'"
            width="160"
            height="160"
          />
        </div>
  
        <div class="labels-wrapper">
          <div class="token-id">#0000</div>
          <div class="label">Loading...<br />&nbsp;</div>
          <div class="date">&nbsp;</div>
        </div>
      </div>
    </div>
  </section>
</ng-template>